import "./Methode.css";
import { Link } from "react-router-dom";
import stats from "../images/entretienpourmethode.jpg";
import methode_etape2 from "../images/Image_methode_étape2.jpg";
import methode_etape1 from "../images/image_methode_étape1.jpg";
import methode_etape4 from "../images/image_methode_etape4.jpg";

import coaching1 from "../images/coaching1.JPG";
import coaching2 from "../images/coaching2.jpg";
import {Helmet} from "react-helmet";

function MethodePage(){

   



  return(

   <div className="Contact Page">


<Helmet>
       
       <title>Notre méthode pour préparation sur mesure aux entretiens</title>
       <meta name="description" content="La méthode winentretien basée sur la recherche des faits personnels de votre parcours, vos points forts et la projection sur un projet professionnel précis"></meta>
       <link rel="canonical" href="https://www.winentretien.com/Methode_page" />

      </Helmet>



<div id="titre_second"class='column_items_center'>
                              
                              <h1>Méthode de préparation aux entretiens de motivation</h1>
                              <h2under2></h2under2>
                              

                  <div class="note"><content> <blue>Mettre des mots sur ce qui vous définit, vous donner confiance en vos possibilités</blue><br/>
                  C'est en partant de ce qui fait l'unicité de votre candidature que vous pourrez le mieux convaincre votre interlocuteur </content><br />
</div>
                              
                              
                        </div>

                        <div class="methode_step column">
         <h3>Mes valeurs</h3>
         <h2under2></h2under2> </div> 

<div class="line_between window valeur">




<div class="column_items_center block" id="method_background">


      <div class="image_methode">
      <i class="fa-solid fa-heart fa-2xl"></i>
      </div>
      
      <div class="row">
      
      <div id='box_graph' class="column_items_center">

      <div id="circle"></div>
      <div id="dropbar"></div>
      

      </div>

      
      
      <div class='column'>
      <div class="row">
      <h2title>
      Bienveillance
      
      </h2title>
      
      </div>
      
      <div id='box_content' >
      <content1>
      La bienveillance désigne pour moi une intention de compréhension et d’indulgence vers autrui.
Cette attitude vise à favoriser le bien-être de <blue>l’autre.</blue><br/><br/>
Dans un contexte professionnel, elle se traduit par une <blue>attitude d’écoute et de soutien.</blue>
<br/>
</content1>
      </div>


      </div>


              </div>

</div>

<div class="column_items_center block" id="method_background">
<div class="image_methode"><i class="fa-solid fa-cloud fa-2xl"></i></div>
<div class="row">


      <div id='box_graph' class="column_items_center">

      <div id="circle"></div>
      <div id="dropbar"></div>
      

      </div>

      
      
      <div class='column'>
      <div class="row">
      <h2title>
      Equanimité
      
      </h2title>
      
      </div>
      
      <div id='box_content' >
      <content1>
      L’équanimité, c’est la capacité à entendre l’autre sans porter de jugement ni faire d’évaluation.
Elle consiste à ne pas émettre de jugement personnel sur les croyances et modes de fonctionnement
de son interlocuteur afin de mieux pouvoir <blue>l’orienter et le conseiller.</blue>
<br/>
</content1>



      </div>


      </div>


              </div>
      

      
</div>


<div class="column_items_center block" id="method_background">

<div class="image_methode"><i class="fa-solid fa-ice-cream fa-2xl"></i></div>

<div class='column'>
<div class="row">

<div id='box_graph' class="column_items_center">

      <div id="circle"></div>
      <div id="dropbar"></div>
      

      </div>

<div class="column">

<h2title>
Plaisir

</h2title>



<div id='box_content'>
<content1>
Les pauses et les moments de légèreté pendant nos entretiens sont des instants de partage et
d’ancrage bénéfiques à chacun, coach et client.<br/>
Ils permettent le <blue>lâcher-prise</blue> et favorisent l’irruption d’idées souvent <blue>innovantes</blue> parce que non
contrôlées.
</content1>



</div>
</div>

</div>


</div>

</div>


<br/><br/>
</div>



                        <div class="column_items_center">
                        <h2><h2title>Ma méthode de préparation aux entretiens en 5 étapes</h2title></h2>
                        <h2under2></h2under2>
                        <div class="note column_items_center">
                        <content1>La méthode qui suit est celle utilisée pour la préparation aux entretiens de motivation : concours
d’entrée dans les grandes écoles, entretien de stage, entretien d’embauche.</content1>
                        </div>
                        </div>
                        
   <div class="methode_step column">
         <h3>Étape 1 : parler de votre projet</h3>
         <h2under></h2under> </div>            


<div class="flex block window methode_part2">
<div class="methode_text">

<content1><strong>C’est grâce aux <blue>600 personnes accompagnées depuis 2007</blue> que la méthode <blue>win</blue>entretien a été mise au point.</strong><br/><br/>

Vous arrivez avec un <strong>objectif précis</strong> :<br/>
● rédiger une lettre de motivation convaincante (Parcoursup),<br/>
● réussir un entretien de motivation<br/>
● réussir un entretien d’embauche<br/><br/>
Pendant une séance gratuite de 30 minutes, je vous interroge sur votre motivation à atteindre cet
objectif et l’aide que vous recherchez.</content1>


      
</div>
<div class="column mobile_off">
<img class="image_methode_2" src={methode_etape1} alt=""/>
<br/>
</div>

  </div> 


  <div class="methode_step column">
         <h3>Étape 2 : répondre à 15 questions</h3>
         <h2under></h2under> </div>            


<div class="flex block window methode_part2">
<div class="methode_text">

<content1>

<strong>Nous avons décidé de travailler ensemble sur votre objectif : c’est votre projet.</strong><br/><br/>
Un questionnaire winentretien vous est envoyé comportant 15 questions structurantes pour la suite.
Les questions portent sur votre environnement, vos <blue>valeurs,</blue> les clés de votre <blue>motivation</blue>, et vos
atouts pour <blue>réussir.</blue><br/><br/>
Une fois ce questionnaire retourné, nous pouvons programmer une première séance de travail, en
présentiel ou en distanciel, à votre convenance.</content1>


      
</div>
<div class="column mobile_off">
<img class="image_methode_2" src={methode_etape2} alt=""/>
<br/>
</div>

  </div> 





  <div class="methode_step column">
         <h3>Étape 3 : améliorer vos réponses</h3>
         <h2under></h2under> </div>  
  






  <div class="flex block window methode_part2">

<div class="column mobile_off">
<img class="image_methode_2" src={stats} id="image_coaching_2" alt=""/>
<br/>
</div>



<div class="column_items_center">


<div class="methode_text">


<content1>
      <strong>Nous identifions les preuves de vos réponses et nous mettons des mots précis sur les éléments de
votre parcours.</strong><br/><br/>
Pendant la séance, je vais vous demander de compléter vos réponses avec des éléments précis,
concrets, et personnels sur les :<br/><br/> <blue>compétences, expériences ou qualités</blue> qui sont les vôtres.
Nous allons nous placer ensemble du point de vue de votre futur interlocuteur, qu’il soit membre
d’un jury pour un entretien oral, ou lecteur de votre lettre de motivation.<br/><br/>
Nous allons choisir les mots pour le convaincre en passant en revue les questions susceptibles de
vous être posées en entretien et en y apportant vos réponses, précises et concrètes.

</content1>


      
</div>
<Link to='/rendez-vous' onClick={() => window.scrollTo(0,10)}>
                                    <button id='bouton'>Prendre rendez-vous</button>
                                    </Link></div>


  </div>  

  

  <div class="methode_step column">
         <h3>Étape 4 : rédiger un document de synthèse de vos réponses</h3>
         <h2under></h2under> </div> 


  <div class="flex block window methode_part2">



  <img class="image_methode_2" src={methode_etape4} id="image_coaching_4" alt=""/>

<div class="column_items_center">


<div class="methode_text">


<content1>
<strong>Enrichir et documenter le résultat de nos entretiens.</strong><br/><br/>
Après quelques séances – entre 2 et 4 en général – vous avez un document qui reprend l’ensemble
des questions passées en revue et vos réponses, personnelles et inspirées de vos expériences
personnelles et professionnelles.<br/><br/>
Nous y ajoutons le texte de votre pitch, car c’est souvent ce qui vous sera demandé en ouverture
d’entretien : « présentez vous en une ou deux minutes ».<br/><br/>
La sélection des questions que nous abordons ensemble est issue de <blue>l’expérience de winentretien.</blue>
Une fois que nous avons fait le tour de toutes les questions susceptibles de vous être posées, il ne
vous reste plus qu’à vous entraîner.

</content1>


      
</div>
</div>


  </div> 


  <div class="methode_step column" id="etape5">
         <h3>Etape 5 : s’entraîner à l’oral</h3>
         <h2under></h2under> </div> 


  <div class="flex block window methode_part2" id="etape5">





<div class="column_items_center">


<div class="methode_text">


<content1>
<strong>S’approprier vos réponses pour gagner en confiance le jour J</strong><br/><br/>

C’est par la simulation de l’entretien que vous vous appropriez vos réponses, et aussi, que vous
réduisez le niveau de stress qui peut toucher certains candidats.<br/><br/>
Vous prenez confiance en vous, en votre capacité à convaincre, et c’est ce sentiment de contrôle sur
ce que vous avez à dire qui va vous permettre d’avoir de l’assurance, ce qui sera perceptible par vos
interlocuteurs et contribuera en retour à emporter leur adhésion.

</content1>


      
</div>
<Link to='/rendez-vous' onClick={() => window.scrollTo(0,10)}>
                                    <button id='bouton'>Prendre rendez-vous</button>
                                    </Link></div>


  </div>  
  
       
  <br/><br/>
  





    

    
    </div>



  );
    
  }
  
  export default MethodePage;


  /***<div class="flex block window methode_part2">
<div class="methode_text">

<content1>Pour les <strong>services de coaching</strong>, l’objectif qui est le vôtre part souvent d’un constat négatif : stress, difficultés
d’organisation ou de communication, perception négative de ses résultats.

Parce que la perception que l’on a d’un problème contient en partie sa résolution, nous allons travailler sur sa 
<blue> formulation</blue>, sur sa <blue> réalité objective</blue>, sur la <blue> manière dont vous le ressentez.</blue><br/><br/>

<blue>L’écoute active</blue>, avec ses corollaires que sont la reformulation et le questionnement, sera le socle de tous nos
échanges.<br/><br/>

Elle permet d’instaurer la confiance et la compréhension, et pour peu qu’on se laisse entraîner par sa simplicité
apparente, elle permet au pouvoir des mots de faire son œuvre. 

</content1>
      
</div>
<div class="column">
<img class="image_methode_2" src={coaching2} id="image_coaching" alt=""/>
<br/>
</div>

  </div>  */